<template>
    <i class="icon"></i>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { Icons } from '@/components/ui/icon/index'
import { iconValues } from '@/components/ui/icon/index'

const props = defineProps<{
    icon: Icons | undefined
}>()

const content = computed(() => props.icon && `var(${iconValues[props.icon]})`)
</script>

<style lang="scss" scoped>
.icon {
    font-size: inherit;

    &::before {
        font-family: $icon-font;
        content: v-bind(content);
    }
}
</style>
